import React from 'react';

export const ThumbsUpIcon = ({ 
  size = 20, 
  color = 'currentColor', 
  strokeWidth = 1.5,
  className = ''
}) => {
  const thumbStroke = strokeWidth * 2;

  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 40 40" 
      fill="none"
      className={className}
    >
      <path
        d="M3 21.6C3 19.6117 4.61177 18 6.6 18C9.58233 18 12 20.4176 12 23.4V30.6C12 33.5824 9.58233 36 6.6 36C4.61177 36 3 34.3883 3 32.4V21.6Z"
        stroke={color}
        strokeWidth={thumbStroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.1312 12.1059L25.6873 13.7249C25.3237 15.0515 25.1418 15.7148 25.2817 16.2387C25.3948 16.6624 25.6432 17.0278 25.9817 17.2681C26.4 17.5652 27.0328 17.5652 28.2985 17.5652H28.9718C33.2553 17.5652 35.397 17.5652 36.4087 18.9973C36.5242 19.1608 36.627 19.335 36.716 19.5176C37.4942 21.1145 36.6095 23.2661 34.84 27.5691C33.2162 31.5179 32.4042 33.4923 30.8967 34.6545C30.7508 34.7669 30.6008 34.873 30.4472 34.9724C28.86 36 26.8937 36 22.9607 36H22.1077C17.3428 36 14.9605 36 13.4802 34.3802C12 32.7603 12 30.1532 12 24.9391V23.1064C12 20.3663 12 18.9963 12.4306 17.7423C12.8611 16.4883 13.6856 15.4572 15.3345 13.3951L22.1535 4.86694C22.3245 4.65307 22.41 4.54611 22.4855 4.472C23.1892 3.78029 24.2753 3.85815 24.8907 4.64443C24.9567 4.72866 25.0287 4.84689 25.1727 5.08337C25.398 5.45327 25.5107 5.63823 25.609 5.82146C26.488 7.46189 26.754 9.41056 26.3513 11.2605C26.3063 11.4671 26.248 11.6802 26.1312 12.1059Z"
        stroke={color}
        strokeWidth={thumbStroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
